export const STATES = {
    PENDING: 'PENDING',
    SYNCED: 'SYNCED',
    FAILED: 'FAILED',
    STALE: 'STALE',
};
export const VERBS = {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};
//# sourceMappingURL=constants.js.map